import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from "react-router-dom";
import { CurrencyForm } from "./tabs/CurrencyForm";
import { DetailsForm } from "./tabs/DetailsForm";
import { TermsForm } from "./tabs/TermsForm";
import { SettingsForm } from "./tabs/SettingsForm";
import { ChargesForm } from "./tabs/ChargesForm";
import tabList from "./tabs/tabList.json";
import { AccountingForm } from "./tabs/AccountingForm";
import RecordStatus from "../../../../components/RecordStatus";
import CustomButton from '../editLoanProduct/customButton'
import { Card, Form, Spin } from 'antd';


const LoanProductTabs = (props) => {

    const navigate = useNavigate();
    const [activeTabKey, setActiveTabKey] = useState("details");
    const [loading, setLoading] = useState(true);

    const onTabChange = (key) => {
        setActiveTabKey(key);
    };

    useEffect(() => {
        // Simulate an API call or data fetching
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }, []);

    function onCancel() {
        navigate("/prd0200", { replace: false });
    }

    const contentListNoTitle = {
        details: <DetailsForm loanProductDetails={props.loanProductDetails} useForm={props.useForm}/>,
        currency: <CurrencyForm loanProductDetails={props.loanProductDetails} useForm={props.useForm}/>,
        terms: <TermsForm loanProductDetails={props.loanProductDetails} useForm={props.useForm}/>,
        settings: <SettingsForm loanProductDetails={props.loanProductDetails} useForm={props.useForm}/>,
        charges: <ChargesForm loanProductDetails={props.loanProductDetails} useForm={props.useForm}/>,
        accounting: <AccountingForm loanProductDetails={props.loanProductDetails} useForm={props.useForm}/>
    };

    return (
        <Spin spinning={loading} size="large">
            <Card
                style={{
                    width: "100%",
                    boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                    borderRadius: 20,
                    marginBottom: "5vh"
                }}
                tabList={tabList}
                activeTabKey={activeTabKey}
                onTabChange={onTabChange}
                tabProps={{
                    size: "middle",
                }}
            >
                {contentListNoTitle[activeTabKey]}
            </Card>
        </Spin>
    );
}

export default LoanProductTabs